module.exports = __webpack_public_path__ + "static/media/signal-stream.e83bb947.svg";